import * as angular from 'angular';
import * as $ from 'jquery';
import { IConfigurationObject } from './services';

export const wtConfig = 'wtConfig';

export function wtConfigProvider() {
    const envConfig: Partial<IConfigurationObject> & { test?: string } = {
        test: 'test'
    };
    const q = $.ajax({
        type: 'GET',
        url: 'config.json',
        cache: false,
        async: false,
        contentType: 'application/json',
        dataType: 'json'
    });
    if (q.status === 200) {
        angular.extend(envConfig, angular.fromJson(q.responseText));
    }

    envConfig['$get'] = () => envConfig;
    return envConfig;
}
